var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 603,
    height: 497,
    viewBox: "0 0 603 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 495,
    width: 527,
    height: 2,
    rx: 1,
    fill: "#1B1B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.838 128.557L341.774 123.53V110.939V98.2934H337.174C337.174 98.2934 331.574 89.957 331.574 89.3752C331.574 88.7934 327.029 79.0025 326.583 76.248C326.138 73.4934 324.838 67.3389 325.238 62.4571C325.638 57.5753 325.692 56.7571 325.692 56.7571L323.874 48.5753L325.756 34.5026L321.365 31.5117C321.365 31.5117 316.656 26.739 316.656 21.639C316.656 16.539 318.202 11.2299 320.465 8.95721C322.729 6.68449 331.201 -0.179133 344.765 1.17541C358.329 2.52995 374.174 14.1299 374.174 14.1299L377.356 13.2208C377.356 13.2208 387.547 15.1299 392.683 23.2844C397.82 31.439 396.32 53.2844 396.32 53.2844L395.31 57.3207V59.6207L394.465 63.1298L391.865 63.4116C391.865 63.4116 391.356 70.9843 387.72 74.1571C384.083 77.3298 384.501 77.9025 384.501 77.9025V108.112H370.71L367.229 118.112L351.838 135.875L349.765 131.266L351.838 128.557Z",
    fill: "#F8EFE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M361.891 124.586L341.772 149.013V123.531L361.891 124.586Z",
    fill: "#F8EFE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341.773 127.191V102.418",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M384.5 108.101V70.8008",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M343.219 69.149C341.401 70.6035 338.201 70.8944 336.782 70.7853C335.064 70.6581 334.564 69.6762 334.591 68.5581C334.714 63.1275 335.255 57.7145 336.21 52.3672",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M334.594 46.4742C333.327 45.8087 331.897 45.5193 330.471 45.6401C329.046 45.7609 327.685 46.2869 326.548 47.1561",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M334.181 20.293C330.583 24.0346 327.804 28.4855 326.023 33.3614C324.241 38.2373 323.496 43.4311 323.835 48.6111C323.835 48.6111 325.654 54.6656 325.654 56.7929C325.654 58.9201 323.899 65.9838 327.081 77.4928C329.003 84.0782 331.698 90.4131 335.108 96.3655C335.551 97.1471 336.193 97.7972 336.969 98.2492C337.746 98.7012 338.628 98.939 339.526 98.9382H349.608C352.326 98.9378 354.976 98.0822 357.181 96.4928C363.317 92.0928 375.717 82.9474 377.763 79.5747C380.49 75.0292 380.562 67.6474 380.562 67.6474",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M380.759 62.4914C383.223 62.4914 384.805 61.1642 386.668 58.9642C388.387 56.9551 389.741 53.7915 389.05 48.0551C387.578 35.7369 375.941 37.7551 375.941 47.3733",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M376.469 43.9832C376.469 43.9832 367.451 49.4377 358.36 31.5469",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M354.484 27.8949C354.484 27.8949 337.33 12.9677 325.721 24.5767",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M342.454 46.3412C346.699 45.0594 352.454 45.4321 354.481 46.1321C356.508 46.8321 361.172 51.7412 361.172 51.7412",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M386.812 74.575C386.812 74.575 393.685 72.1841 391.403 63.4023",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M396.156 67.9029C395.886 66.2199 395.313 64.5997 394.465 63.1211",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M375.939 13.0273C392.157 14.8455 396.32 29.1637 396.32 35.3727V53.2727",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M378.445 17.721C378.445 17.721 368.954 8.71195 356.8 3.93924C344.645 -0.833478 327.618 -0.23348 320.109 9.39377C312.6 19.021 318.4 28.6664 322 32.2664",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M338.174 78.4582C343.964 79.2582 347.792 77.8945 349.228 77.8945C350.664 77.8945 349.228 83.1854 344.328 83.9127C343.031 84.0699 341.714 83.9108 340.492 83.4491",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M348.237 55.5399C347.951 54.2147 348.436 52.9861 349.319 52.7957C350.203 52.6054 351.151 53.5253 351.436 54.8505C351.722 56.1757 351.237 57.4043 350.353 57.5947C349.47 57.7851 348.522 56.8651 348.237 55.5399Z",
    fill: "#1B1B1B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M329.026 56.247C328.74 54.9218 329.225 53.6932 330.108 53.5028C330.992 53.3124 331.94 54.2324 332.225 55.5576C332.511 56.8828 332.026 58.1114 331.143 58.3017C330.259 58.4921 329.311 57.5721 329.026 56.247Z",
    fill: "#1B1B1B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M264.174 167.651C271.247 162.069 306.81 134.014 311.774 129.014C316.385 124.355 322.458 121.422 328.974 120.705L335.51 119.678L334.601 108.56H341.801V149.014L367.255 118.105L370.737 108.105H389.955L388.137 117.196L389.51 117.733L404.192 123.487C404.555 123.587 404.919 123.705 405.274 123.842L405.737 124.005C413.119 126.796 418.319 134.333 424.501 150.833C432.601 172.423 446.219 216.832 449.955 230.832C451.474 236.532 450.955 241.105 448.41 244.469C445.146 248.723 438.628 250.878 429.046 250.878C423.528 250.878 415.246 249.323 406.483 247.669C399.01 246.26 390.546 244.669 382.974 243.941L384.246 244.323L380.355 255.941C380.355 255.941 356.919 257.623 348.256 264.005C342.613 268.251 337.397 273.038 332.683 278.296L291.774 278.078L288.838 273.832C287.19 271.447 286.056 268.745 285.508 265.899C284.961 263.052 285.011 260.122 285.656 257.296L301.928 179.451L300.174 180.469C291.701 185.351 280.683 191.742 276.31 194.469C273.765 196.06 267.819 199.778 261.238 199.778C258.941 199.764 256.672 199.282 254.568 198.362C252.464 197.441 249.001 194.423 249.001 194.423L264.174 167.651ZM413.137 222.487L401.019 194.878L391.465 222.669L413.137 222.487Z",
    fill: "#EBC7B5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M298.517 195.877L304.508 167.195Z",
    fill: "#F8EFE5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M298.517 195.877L304.508 167.195",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M335.458 118.992L334.585 108.556H341.776V149.011L367.23 118.102L370.721 108.102H389.203",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M270.998 198.036C273.069 197.121 275.065 196.048 276.971 194.827C278.544 193.845 289.08 187.664 291.898 186",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M298.517 195.877L304.508 167.195Z",
    fill: "#F8EFE5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M298.517 195.877L304.508 167.195",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M449.96 230.828C453.596 244.464 445.414 250.828 429.051 250.828C416.323 250.828 389.514 242.646 372.687 243.555C371.215 243.619 369.767 243.952 368.414 244.537",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M355.177 225.301C357.94 224.528 360.753 223.945 363.595 223.555C377.232 221.737 413.141 222.482 413.141 222.482C413.141 222.482 401.632 195.11 389.923 171.246",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M340.237 230.667C343.906 229.63 347.426 228.123 350.71 226.186L370.874 146.131C377.383 118.386 399.301 121.931 405.273 123.84C404.919 123.704 404.555 123.586 404.192 123.486L391.019 118.295C389.94 117.869 388.788 117.659 387.628 117.677C376.592 117.868 368.974 124.177 363.937 140.004C361.992 146.122 349.701 194.413 340.237 230.667Z",
    fill: "#1B1B1B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M329.61 271.44C329.61 271.44 330.519 267.503 332.674 259.312C335.389 261.002 338.318 262.32 341.383 263.231L339.565 270.34L329.61 271.44Z",
    fill: "#1B1B1B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M318.602 132.05C320.82 123.796 323.339 119.187 335.875 118.414V119.532C332.02 121.45 328.602 125.523 326.893 133.387L300.293 272.096L293.166 271.386C293.166 271.386 315.921 142.087 318.602 132.05Z",
    fill: "#1B1B1B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M318.406 254.539L314.661 271.439",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M341.781 149.012L321.745 239.466",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M406.553 222.484L422.008 222.739",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4879 251.645C78.4879 262.717 89.6243 271.699 103.37 271.699C117.115 271.699 128.297 262.717 128.297 251.645H78.4879Z",
    fill: "#F8EFE5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M103.365 271.699H110.529C111.648 271.698 112.756 271.918 113.79 272.345C114.824 272.773 115.763 273.4 116.555 274.191C117.346 274.983 117.973 275.922 118.401 276.956C118.829 277.99 119.048 279.098 119.047 280.217H87.6833C87.6833 277.958 88.5807 275.792 90.1782 274.194C91.7757 272.597 93.9423 271.699 96.2015 271.699H103.365Z",
    fill: "#F8EFE5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M103.366 271.699C103.366 271.699 105.038 272.208 107.193 272.817C111.475 274.017 117.675 275.545 116.556 274.217L116.447 274.099C116.06 273.728 115.737 273.295 115.493 272.817C115.315 272.433 115.237 272.01 115.266 271.587C115.294 271.165 115.429 270.756 115.656 270.399C116.424 269.242 117.424 268.258 118.593 267.508C119.056 267.163 119.575 266.808 120.156 266.445L120.229 266.39L120.702 266.035C121.463 265.193 122.303 264.426 123.211 263.745L111.393 261.672L104.42 270.399L103.366 271.699Z",
    fill: "#F8EFE5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5258 263.746C84.4104 264.395 85.224 265.135 85.953 265.955L86.5621 266.428H86.6257C87.153 266.755 87.6348 267.082 88.0621 267.4C89.2537 268.162 90.2751 269.162 91.0621 270.337C91.2898 270.694 91.4241 271.102 91.4527 271.525C91.4813 271.947 91.4032 272.37 91.2257 272.755C90.9953 273.229 90.6882 273.662 90.3166 274.037L90.2076 274.155C89.0894 275.518 95.2893 273.955 99.5712 272.755C101.726 272.146 103.398 271.637 103.398 271.637L102.362 270.337L95.3894 261.609L83.5258 263.746Z",
    fill: "#F8EFE5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4852 249.227H128.258V251.645H78.4852V249.227Z",
    fill: "#1B1B1B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2381 272.836H115.493C115.315 272.452 115.237 272.029 115.266 271.606C115.294 271.184 115.429 270.775 115.656 270.418H91.1109C91.3328 270.778 91.4608 271.188 91.483 271.611C91.5052 272.033 91.421 272.455 91.2381 272.836V272.836Z",
    fill: "#1B1B1B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M112.462 495.289H136.18L132.462 493.834L119.052 494.007L112.798 493.834L112.807 485.698L119.052 478.253V287.453H112.462V491.734H98.0707L95.1889 495.289H112.462Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M58.595 277.492V287.492H153.267C153.267 287.492 152.413 284.574 153.977 277.492H58.595Z",
    fill: "#EBC7B5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M473.216 439.45C473.325 443.989 473.543 448.534 473.871 453.086C474.301 459.147 474.907 465.228 475.689 471.331C475.771 471.941 475.853 472.541 475.943 473.15C476.943 480.356 478.216 487.586 479.762 494.84H509.198C510.743 487.568 512.016 480.337 513.016 473.15C513.107 472.541 513.189 471.941 513.271 471.331C514.083 465.241 514.689 459.159 515.089 453.086C515.416 448.534 515.634 443.989 515.743 439.45C516.258 418.189 514.429 396.937 510.289 376.077C509.943 374.259 509.574 372.465 509.18 370.695H479.78C479.386 372.513 479.016 374.307 478.671 376.077C474.531 396.937 472.702 418.189 473.216 439.45V439.45Z",
    fill: "#F8EFE5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M473.876 453.086C474.306 459.147 474.912 465.228 475.694 471.331C475.776 471.94 475.857 472.54 475.948 473.15H513.021C513.112 472.54 513.194 471.94 513.276 471.331C514.088 465.24 514.694 459.159 515.094 453.086H473.876Z",
    fill: "#1B1B1B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M478.687 376.077H510.305C509.959 374.259 509.59 372.465 509.196 370.695H479.796C479.396 372.489 479.026 374.283 478.687 376.077Z",
    fill: "#1B1B1B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M189.377 485.856C186.708 485.279 183.928 485.516 181.396 486.538L180.868 486.656H180.541C179.477 486.656 178.405 486.656 177.332 486.547C175.014 486.401 172.705 486.138 170.386 485.965C163.65 485.456 157.432 485.056 150.696 485.965C138.45 487.647 125.305 485.901 112.796 485.683V481.829C112.796 479.956 112.45 477.738 115.75 475.465C119.05 473.192 122.905 472.447 133.932 470.083C144.959 467.719 154.041 459.492 154.041 459.492L154.75 452.556L157.068 451.02H169.95V458.974H181.768L188.814 459.42L192.25 470.329L191.268 481.483L189.377 485.856Z",
    fill: "#F8EFE5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M115.758 475.492C119.049 473.219 122.913 472.474 133.94 470.11C144.967 467.747 154.049 459.52 154.049 459.52L154.758 452.583L157.076 451.02H167.54L169.44 452.038L169.958 458.974H181.776L188.821 459.42L192.258 470.329L191.276 481.483L189.167 486.31C187.338 485.896 185.447 485.831 183.594 486.119C179.049 486.819 163.594 486.647 162.912 486.538H163.031C160.444 486.096 157.789 486.289 155.294 487.101C152.694 487.047 150.103 486.992 147.549 486.965C141.476 486.91 135.44 486.529 129.367 486.274C123.849 486.056 118.34 486.274 112.822 486.174V485.592V481.783C112.84 479.974 112.458 477.756 115.758 475.492Z",
    fill: "#F8EFE5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M184.393 494.012H116.893C115.717 494.012 114.588 493.545 113.756 492.713C112.924 491.881 112.457 490.753 112.457 489.576V486.285H188.82V489.576C188.821 490.158 188.708 490.735 188.486 491.273C188.264 491.811 187.938 492.3 187.527 492.712C187.116 493.125 186.627 493.451 186.089 493.675C185.552 493.898 184.975 494.012 184.393 494.012Z",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M188.823 486.284C193.523 483.093 193.686 459.221 187.523 459.012H169.959",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M169.961 461.701V453.601C169.966 453.262 169.902 452.925 169.775 452.61C169.647 452.295 169.458 452.009 169.219 451.768C168.979 451.528 168.693 451.337 168.379 451.209C168.065 451.08 167.728 451.016 167.388 451.02H157.052C156.39 451.022 155.757 451.287 155.29 451.755C154.823 452.224 154.561 452.858 154.561 453.52V458.974L147.697 463.356C142.224 466.855 136.271 469.538 130.024 471.32L116.234 475.247C115.125 475.627 114.163 476.344 113.482 477.298C112.801 478.251 112.434 479.393 112.434 480.565V486.247",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M152.527 460.328L161.781 470.828",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M146.317 464.438L153.117 472.765",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M141.245 467.828L146 474.228",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M169.497 453.559L169.951 459.013L180.106 457.995C180.106 457.995 181.46 453.559 178.56 453.559H169.497Z",
    fill: "#1B1B1B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M338.056 306.658C350.147 279.894 360.147 271.74 380.865 271.74H408.138C440.011 271.74 460.565 263.74 472.047 246.285C459.483 279.012 437.22 316.285 422.883 340.339L422.429 341.103C418.83 347.096 413.745 352.057 407.666 355.507C401.586 358.957 394.719 360.778 387.729 360.794L297.729 360.339C315.484 353.521 326.665 331.93 338.056 306.658Z",
    fill: "#F8EFE5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M307.812 324.465L256.222 324.601L251.585 328.719C251.585 328.719 241.931 345.565 242.767 345.565H275.867C276.931 345.565 286.367 343.747 289.922 341.765C293.476 339.783 302.912 331.365 302.912 331.365L307.812 324.465Z",
    fill: "#F8EFE5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M443.75 265.984C434.05 269.221 422.268 270.83 408.141 270.83H380.868C360.868 270.83 349.959 278.103 337.232 306.284C330.468 321.275 323.441 336.002 314.505 346.511",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M420.005 135.867C477.341 144.54 487.369 191.567 480.005 224.467",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M439.091 156.664C443.335 158.722 447.28 161.346 450.818 164.464C463.7 175.928 468.091 193.437 466.382 210.309C463.436 240.027 449.109 255.764 405.473 255.764H378.2C358.2 255.764 335.409 265.764 322.746 293.946C309.055 324.464 301.182 345.527 270.927 345.527H243.655",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M272.082 223.284C279.701 218.673 286.774 213.214 293.164 207.012",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M164.664 268.512C156.837 276.121 151.028 286.812 153.755 301.284C157 318.103 164.273 336.693 179.209 348.466C193.228 359.502 190.418 357.421 190.418 357.421",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M267.229 361.739H387.729C394.876 361.736 401.899 359.879 408.114 356.35C414.328 352.82 419.52 347.739 423.183 341.603C440.574 312.439 470.274 262.83 479.547 226.094",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M275.862 361.738C284.499 361.738 300.717 361.738 300.717 383.711C300.717 405.684 297.517 495.293 297.517 495.293H304.79C304.79 495.293 307.99 401.929 307.99 383.747C307.99 361.775 329.953 361.775 329.953 361.775L275.862 361.738Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M270.447 361.738C270.447 361.738 280.284 361.82 277.602 374.72L247.675 495.293H253.584L284.165 375.766C285.123 371.26 287.589 367.216 291.156 364.302L285.411 361.738H270.447Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M373.401 361.737C373.401 361.737 376.21 361.864 380.965 361.828C392.837 361.737 399.147 380.292 399.147 380.292L435.828 495.291H443.383C443.383 495.291 421.71 426.473 413.383 400.482C405.056 374.492 404.165 373.619 426.965 335.301C426.965 335.301 417.474 354.337 401.237 359.246C389.201 364.655 373.401 361.737 373.401 361.737Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M285.414 361.738H235.969",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M184.178 385.947C185.26 373.047 181.951 361.074 167.951 337.547C172.415 342.59 177.37 347.176 182.742 351.238C190.478 356.801 190.433 357.42 190.433 357.42L195.188 375.256L186.551 385.947H184.178Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M364.724 247.65C366.542 246.741 368.488 244.014 368.488 244.014C368.488 244.014 370.079 237.259 366.606 232.677C363.133 228.096 355.17 225.305 355.17 225.305L334.897 232.986L323.024 238.214L313.297 247.65L305.624 259.314L306.452 262.041L307.97 262.423C307.97 262.423 310.524 262.159 310.524 261.514C310.524 260.868 320.406 252.423 320.406 252.423L328.479 245.377L326.452 253.441C326.298 254.079 326.306 254.746 326.475 255.381C326.643 256.015 326.966 256.598 327.415 257.077C328.933 258.596 334.915 261.168 334.915 261.168L343.597 263.995H348.288C348.288 263.995 350.897 259.786 350.897 258.196C350.897 256.605 349.27 253.441 349.27 253.441C354.621 252.092 359.804 250.149 364.724 247.65V247.65Z",
    fill: "#F8EFE5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M329.626 242.059C329.626 242.059 327.236 250.049 326.517 254.195C326.37 254.997 326.514 255.826 326.924 256.531C327.335 257.236 327.983 257.772 328.754 258.04L332.672 259.313",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M334.97 244.273C334.97 244.273 332.579 252.264 331.87 256.41C331.718 257.211 331.86 258.041 332.269 258.747C332.678 259.453 333.327 259.988 334.097 260.255L338.016 261.528",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M340.275 247.457C339.045 251.12 338.025 254.85 337.22 258.63C337.07 259.432 337.212 260.262 337.621 260.969C338.029 261.676 338.677 262.214 339.448 262.484L344.602 264.157C345.44 264.412 346.341 264.357 347.141 264.002C347.941 263.646 348.586 263.014 348.957 262.221L350.675 258.684C350.944 258.134 351.021 257.51 350.892 256.911C350.764 256.313 350.437 255.775 349.966 255.384L349.457 254.966C348.976 254.572 348.36 254.382 347.741 254.434C347.121 254.487 346.547 254.779 346.139 255.248L344.32 257.266",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M368.406 244.539C366.234 245.53 365.179 246.612 363.024 248.457C360.722 250.359 358.046 251.757 355.169 252.56C352.293 253.364 349.279 253.555 346.324 253.121L343.597 258.866",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M328.35 246.548L320.286 251.911C320.085 252.082 319.897 252.267 319.723 252.466L311.795 260.838C311.193 261.536 310.396 262.037 309.506 262.277C308.617 262.516 307.676 262.484 306.805 262.184L306.459 262.057C306.204 261.956 305.975 261.799 305.789 261.598C305.604 261.396 305.466 261.155 305.386 260.893C305.307 260.631 305.287 260.354 305.33 260.083C305.372 259.812 305.476 259.555 305.632 259.329C307.777 256.275 310.895 251.229 315.441 246.438C320.895 240.702 323.368 238.511 327.259 236.875C334.468 233.838 344.532 228.393 355.195 225.32",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M368.413 244.537C368.413 244.537 371.613 228.11 355.176 225.301",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M206.102 413.323C210.975 426.859 214.284 435.723 214.284 435.723C228.248 437.668 237.875 433.677 243.375 423.995L232.02 373.25",
    fill: "#1B1B1B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M206.102 413.323C210.975 426.859 214.284 435.723 214.284 435.723C228.248 437.668 237.875 433.677 243.375 423.995L232.02 373.25",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M201.929 382.518L233.411 301.754L253.047 288.118L248.711 282.036L206.347 276.472C190.12 274.318 169.983 286.027 183.056 332.7C187.265 347.754 189.602 357.009 195.247 373.827",
    fill: "#1B1B1B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M201.929 382.518L233.411 301.754L253.047 288.118L248.711 282.036L206.347 276.472C190.12 274.318 169.983 286.027 183.056 332.7C187.265 347.754 189.602 357.009 195.247 373.827",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M332.688 278.293H239.642C234.902 278.491 230.332 280.111 226.525 282.942C222.718 285.772 219.851 289.683 218.297 294.166L161.779 449.011C169.733 455.32 178.815 459.011 189.961 459.011L251.933 328.011C252.435 326.95 253.227 326.053 254.219 325.426C255.21 324.798 256.36 324.465 257.533 324.466H307.815C315.76 309.575 318.251 303.893 322.742 293.947C325.23 288.247 328.585 282.967 332.688 278.293Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M210.873 417.266L236.109 363.902",
    stroke: "#F8EFE5",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M240.852 278.348H239.642C234.909 278.542 230.343 280.153 226.537 282.974C222.731 285.794 219.86 289.694 218.297 294.166L179.624 395.075",
    stroke: "#F8EFE5",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M389.501 54C389.501 53 389.501 53.5 389.501 52.5C389.501 51.5301 390.001 49.5 389.501 48.5L404.902 63.4662C405.085 63.6532 405.188 63.9045 405.188 64.1662C405.188 64.428 405.085 64.6793 404.902 64.8662L403.52 66.2844C403.334 66.4671 403.085 66.5694 402.824 66.5694C402.564 66.5694 402.314 66.4671 402.129 66.2844L389.501 54Z",
    fill: "#EBC7B5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M369.003 29.2018L379.5 39.5C378.858 39.7323 378.484 40.0178 378 40.5C377.516 40.9822 377.234 41.8584 377 42.5L366.276 32.1018L363.031 26.2109L369.003 29.2018Z",
    fill: "#EBC7B5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M402.153 66.3393C402.339 66.522 402.589 66.6244 402.849 66.6244C403.109 66.6244 403.359 66.522 403.544 66.3393L404.926 64.9121C405.019 64.8215 405.092 64.7133 405.143 64.5939C405.193 64.4744 405.219 64.3462 405.219 64.2166C405.219 64.087 405.193 63.9588 405.143 63.8393C405.092 63.7199 405.019 63.6117 404.926 63.5211L398.717 57.6484C398.823 57.8295 398.867 58.0402 398.843 58.2486C398.818 58.457 398.726 58.6516 398.581 58.803L397.208 60.2212C397.022 60.4066 396.77 60.5107 396.508 60.5107C396.245 60.5107 395.994 60.4066 395.808 60.2212L402.153 66.3393Z",
    fill: "#1B1B1B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M363.027 26.1914L366.273 32.0823L369 29.2278L363.027 26.1914Z",
    fill: "#1B1B1B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M332.683 278.292H172.974C171.806 278.293 170.662 277.956 169.68 277.322C168.697 276.688 167.919 275.785 167.438 274.72L128.884 189.42C128.605 188.805 128.484 188.13 128.53 187.456C128.577 186.782 128.79 186.13 129.15 185.559C129.511 184.988 130.007 184.515 130.595 184.183C131.183 183.851 131.845 183.67 132.52 183.656L249.056 182.02C250.398 182.006 251.715 182.384 252.845 183.108C253.975 183.831 254.87 184.868 255.42 186.093L293.601 271.438H338.492L332.683 278.292Z",
    fill: "#F8EFE5",
    stroke: "#1B1B1B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M200.58 241.412C193.602 235.59 191.231 226.933 195.284 222.075C199.336 217.218 208.278 218 215.256 223.822C222.234 229.644 224.605 238.301 220.552 243.158C216.5 248.016 207.557 247.234 200.58 241.412Z",
    fill: "#EBC7B5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M150.909 209.92H168.109L160.346 192.711H143.137L150.909 209.92Z",
    fill: "#EBC7B5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M144.425 195.447H161.625L160.343 192.711H143.134L144.425 195.447Z",
    fill: "#1B1B1B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1846 426.129C31.1846 441.529 43.9119 454.011 59.6118 454.011C75.3118 454.011 88.0391 441.529 88.0391 426.129H31.1846Z",
    fill: "#F8EFE5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1846 422.582H88.0391V426.118H31.1846V422.582Z",
    fill: "#1B1B1B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6406 438.129H31.1771",
    stroke: "#1B1B1B",
    strokeWidth: 1.63787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2258 438.129L95.8984 494.838",
    stroke: "#1B1B1B",
    strokeWidth: 1.63787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5938 438.129L24.7665 495.292",
    stroke: "#1B1B1B",
    strokeWidth: 1.63787,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M195.181 488.1V480.891L197.453 476.9L203.917 472.645L212.835 450.409L211.39 442.618L213.335 439.418L229.881 440.327L233.008 442.054L234.044 444.654L236.426 442.282L243.062 434.491L242.499 430.473C242.499 430.473 244.926 430.473 246.599 433.564C248.271 436.654 252.008 441.991 252.008 448.636C252.008 455.282 233.317 479.591 233.317 479.591L226.771 488.073L195.181 488.1Z",
    fill: "#F8EFE5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M235.306 448.786L233.616 443.286C233.364 442.47 232.87 441.75 232.199 441.223C231.529 440.695 230.713 440.384 229.861 440.331L215.716 439.422C215.035 439.38 214.355 439.504 213.732 439.783C213.11 440.061 212.565 440.487 212.143 441.022C211.744 441.528 211.466 442.12 211.332 442.75C211.198 443.381 211.211 444.034 211.37 444.658L212.834 450.413L205.361 470.295C204.761 471.895 203.632 473.243 202.161 474.113L197.47 476.904C196.778 477.315 196.205 477.899 195.806 478.599C195.408 479.298 195.198 480.09 195.197 480.895V488.104H226.77C226.77 488.104 247.243 462.495 251.77 451.058C252.313 447.876 251.921 444.605 250.643 441.64C249.077 438.184 247.335 434.81 245.425 431.531C245.425 431.531 244.961 430.504 242.497 430.504C242.497 430.504 245.516 436.868 234.506 443.568",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M195.182 488.105V493.432C195.182 493.678 195.231 493.921 195.325 494.148C195.419 494.374 195.557 494.58 195.731 494.753C195.905 494.927 196.112 495.064 196.339 495.157C196.566 495.25 196.81 495.297 197.055 495.296L229.2 495.223C229.758 495.225 230.307 495.09 230.8 494.83C231.293 494.57 231.714 494.193 232.028 493.732L255.564 459.205C256.077 458.46 256.417 457.61 256.562 456.717C256.707 455.824 256.651 454.911 256.4 454.042C255.882 452.305 253.955 450.124 252.591 448.051",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M212.265 453.285L228.383 453.758",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M209.299 460.578L225.172 461.078",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M206.103 468.102L220.539 468.42",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M196.618 478.258H218.727",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M241.173 427.285L242.991 433.158C243.165 433.966 243.018 434.81 242.582 435.512C240.719 438.909 237.924 441.703 234.528 443.567",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M217.542 436.066L218.633 439.285",
    stroke: "#1B1B1B",
    strokeWidth: 1.4059,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMen);
export default __webpack_public_path__ + "static/media/men.2d09846e0291e43fd171bf8758bcefd9.svg";
export { ForwardRef as ReactComponent };